import {useState} from 'react';
import { ajaxor2 } from "../common/basic";

export default props=>{
	const [noun, setNoun]=useState('A');
	const jsx = (<div className="submenu-bound">
		<style jsx>{`

.menu_box {
    border-bottom: solid 1px #dee2e6;
	background-color: #ffffff;
    width: 1290px;
	height: 400px;

	position: relative;
	z-index: 3;
	
	// box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);

	line-height: 1;
	padding-top:50px;
}

.neon {
	font-size: 14px;
	font-weight: bold;
	line-height: 1.71;
	letter-spacing: -0.25px;
	text-align: center;
	color: #adb5bd;
}

.neon img{
	vertical-align: text-bottom;
}

.neon.highlighted a{
	color: #55d5ce;
}

.noun-list{
	padding-bottom:16px;
}

.word-item{
	padding:16px 40px 16px 0;
}


@media all and (max-width:606px) {
	.menu_box {
		width: auto;
		padding-top:35px;
	}

	.noun-wrapper{
		/* width: 100%; */
		overflow-y: hidden;

		width: 90%;
    	margin: auto;
	}

	.noun-wrapper::-webkit-scrollbar{
		display:none;
	}

	.noun-list{
		width: max-content;
	}

	.word-item{
		width: 33%;
		padding: 16px 0px;
		text-align: center;
	}
}


`}</style>
		<div className="menu_box">
			<div className="noun-wrapper">
			<div className="noun-list">{(typeof props.items !== "undefined") && props.indexes.map((v, i, a) => 
				<div 
					key={i} 
					className={"dib neon " + (v==noun? "highlighted" : null)}
					onClick={() => setNoun(v) }
				>
					&nbsp;{i>0? <img src="/assets/images2/x.svg" /> :null}
					&nbsp;<a>{v}</a>&nbsp;
				</div>
			)}</div>
			</div>
			<div className="horizon-bar" />
			<div className="word-list">
			{
				(typeof props.items !== "undefined")
					&& (typeof props.indexes !== "undefined")
					&& (typeof props.items[props.indexes.indexOf(noun)] !== "undefined") 
					&& props.items[props.indexes.indexOf(noun)].length==0
				?<div className="dib word-item"> &nbsp; ( 없음 ) &nbsp; </div>
				:null
			}
			{
				(typeof props.items !== "undefined") 
				&& (typeof props.indexes !== "undefined") 
				&& (typeof props.items[props.indexes.indexOf(noun)] !== "undefined") 
				&& props.items[props.indexes.indexOf(noun)]
					.map((v, i, a) =>
				<div className="dib word-item"
					key={i}
					onClick={e => {
						ajaxor2({
							url: "/getBrandSlug?kw=" + v, // 슬러그얻기
							callback: cb
						});
						function cb(rd) {
							if (rd[0]) {
								location.href = "/community/brand?kw=" + rd[0].slug;
							} else {
								alert("슬러그가 없는 메뉴입니다.");
							}
						}
					}}
				>&nbsp;<a >{v}</a>&nbsp;
				</div>
			)}</div>

		</div>

	</div>);
	return(jsx);
}

